import React, {Component, createRef} from "react";
import styles from './FJStockVideoHeaderView.module.less';
import FJStockVideoHeaderOptions from "./stockVideo/FJStockVideoHeaderOptions";
import FJLocalStore from "../../../store/FJLocalStore";
import FJViewConstant from "../../../constant/FJViewConstant";
import InlineSVG from "react-inlinesvg";
import VideoIcon from "../../../icon/stock_video.svg";
import PhotoIcon from "../../../icon/stock-photo.svg";
import MusicIcon from "../../../icon/stock_music.svg";
import FJStockVideoHeaderClose from "./stockVideo/FJStockVideoHeaderClose";

class FJStockVideoHeaderView extends Component{

	constructor(props) {
		super(props);

		this._videoRef = createRef();
		this._photoRef = createRef();
		this._musicRef = createRef();

		this._options = [
			{
				icon: <InlineSVG src={VideoIcon}/>,
				span: "stock-video-menu-text",
				type: FJViewConstant.STOCK_VIDEO_VIDEO,
				ref: this._videoRef
			},
			{
				icon: <InlineSVG src={PhotoIcon}/>,
				span: "stock-photo-menu-text",
				type: FJViewConstant.STOCK_VIDEO_PHOTO,
				ref: this._photoRef
			},
			{
				icon: <InlineSVG src={MusicIcon}/>,
				span: "stock-music-menu-text",
				type: FJViewConstant.STOCK_VIDEO_MUSIC,
				ref: this._musicRef
			},
		]

		this.state = {
			cursorStyle: {
				width: '112px',
				left: '40px',
			},
		}
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if (prevProps.activeOption !== this.props.activeOption) {
			this._updateCursor();
		}
	}

	_changeOption = (type) => {
		this.props.cutOptionsAction && this.props.cutOptionsAction(type)
	}

	_updateCursor = () => {
		let target = {
			[FJViewConstant.STOCK_VIDEO_VIDEO] : this._videoRef,
			[FJViewConstant.STOCK_VIDEO_PHOTO] : this._photoRef,
			[FJViewConstant.STOCK_VIDEO_MUSIC] : this._musicRef,
		}[this.props.activeOption];
		if (target) {
			setTimeout(() => {
				let rect = target.current;
				this.setState({
					cursorStyle: {
						width: `${rect.offsetWidth}px`,
						left: `${rect.offsetLeft}px`,
					}
				});
			}, 250);

		}
	}

	_closeModal = () => {
		this.props.closeStockVideoModalAction && this.props.closeStockVideoModalAction();
	}

	_showOptions = () => {
		let {
			activeOption
		} = this.props;

		let items = [];

		this._options.forEach((item, index) => {
			 items.push(
				 <FJStockVideoHeaderOptions key={index}
																		text={FJLocalStore._(item.span)}
																		icon={item.icon}
																		active={activeOption === item.type}
																		optionRef={item.ref}
																		onClick={this._changeOption}
																		type={item.type}

				 />
			 )
		})

		return items;
	}

	render() {

		let {
			cursorStyle
		} = this.state;

		return (
			<div className={styles.header_container}>
				{this._showOptions()}

				<div className={styles.cursor} style={cursorStyle}/>

				<FJStockVideoHeaderClose onClick={this._closeModal}/>
			</div>
		)
	}

}


export default FJStockVideoHeaderView;